module.exports = __webpack_public_path__ + "static/media/anonymous-avatar.fc19588b.svg";